// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1vUtX","amount":"Amount_amount__3EfLV","tip":"Amount_tip__vMrL6","tipHeader":"Amount_tipHeader__3pZJi","tipsWrap":"Amount_tipsWrap__21JtN"};